var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid pt-5 pb-2 text-right scroll"},[_c('button',{staticClass:"btn scrollBtn",on:{"click":_vm.scrollToTop}},[_c('i',{staticClass:"bi bi-chevron-double-up"})])])}
var staticRenderFns = []

export { render, staticRenderFns }